import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {SignUpService} from "../../service/sign-up.service";
import {RegistrationBaseComponent} from "../registration-base-component/registration-base-component";
import {RegistrationApiService} from "../../api/registration-api.service";
import {CoreApiService} from "../../../core/service/core-api.service";
import {FormFieldDto} from "../../../core/interfaces/core.types";
import {Form} from "@angular/forms";
import {FieldAccess} from "../../types/registration.types";


@Component({
  selector: 'registration-notifications',
  templateUrl: './registration-notifications.component.html',
  styleUrl: './registration-notifications.component.scss'
})
export class RegistrationNotificationsComponent extends RegistrationBaseComponent {

  fields: string[] | undefined = ["confirmContactViaPhone", "confirmEmail", "confirmNotifications", "confirmWhatsApp", "confirmNewsletter", "confirmSms"];
  notificationFields: FormFieldDto[] | undefined;

  constructor(protected override registrationApiService: RegistrationApiService,
              protected override  signUpService: SignUpService,
              protected override coreApiService: CoreApiService) {
    super(registrationApiService,signUpService,coreApiService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  override initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  override refreshComponent() {
    this.createFields();
    this.initialized = true;
  }

  createFields() {
    if (!this.notificationFields) {
      this.notificationFields = [];
    }

    const formFields = this.signUpService.registrationForm.formFields;

    for (let field of this.fields as string[]) {
      if (formFields[field]?.access == FieldAccess.HIDDEN) {
        continue;
      }
      this.notificationFields.push(formFields[field]);
    }

    if (this.notificationFields.length > 0) {
      this.notificationFields.sort((a, b) => {
        // Treat undefined as the lowest priority
        const valA = a.uiMandatory === undefined ? -1 : a.uiMandatory ? 1 : 0;
        const valB = b.uiMandatory === undefined ? -1 : b.uiMandatory ? 1 : 0;

        return valB - valA; // Sort in descending order: true > false > undefined
      });
    }

  }

  isFormValid(): boolean {
    const fields: string[] = [];

    for (let field of this.notificationFields!) {
      if (field.uiMandatory == true) {

        const formControlValue = this.formGroup.get(field.id)?.value;
        if (!formControlValue) {
          return false;
        }

      }
    }

    return this.isActiveFormValid(fields);
  }

  override postObjectRefresh() {
    this.navigateNextStep(3);
  }



}
